export default "__VITE_ASSET__CPLtuK6v__"